export default __webpack_public_path__ + "static/media/legal-g.024bbffc.svg";